<template>
    <div id="royal-bonuses_table_component"
         class="futurocoin-table-component">
        <p style="margin-top: 25px;">Bonuses</p>
        <div class="futurocoin-table-outer table-responsive">
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                    <tr>
                        <th><p>Bonus</p></th>
                        <th><p>Amount</p></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(amount, bonus) in royalBonusesList"
                        v-if="amount > 0"
                        :key="index">
                        <td>
                            <p>{{ bonus.replace('_', ' ') }}</p>
                        </td>
                        <td>
                            <p>{{ money.format(amount, 'fto') }} FTO</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['royalBonuses', 'money'],
        computed: {
            royalBonusesList() {
                return this.$store.getters.royalBonuses;
            }
        },
        methods: {
            /**
             * Get data
             */
            getData() {
                this.royalBonuses.fetchData()
            }
        },
        beforeMount() {
            this.getData();
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .futurocoin-table-component {
        position: relative;
    }

    .futurocoin-table-outer {
        margin: 11px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin/RoyalBonusesTable.vue